/** Fire-and-forget client error → POST /api/v2/logs/client (NLog). Never throws. */
export function reportClientError(
  apiBase: string,
  payload: {
    message: string
    level?: string
    source?: string
    stack?: string
    kind?: string
    siteId?: string
  },
): void {
  try {
    const body = JSON.stringify({
      level: payload.level ?? 'error',
      message: payload.message,
      source: payload.source ?? 'vue',
      stack: payload.stack,
      kind: payload.kind ?? 'runtime',
      siteId: payload.siteId || undefined,
      url: typeof location !== 'undefined' ? location.href : undefined,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    })
    void fetch(`${apiBase}/api/v2/logs/client`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {})
  } catch {
    /* ignore */
  }
}

export function installVueErrorReporting(
  app: { config: { errorHandler?: ((err: unknown, instance: any, info: string) => void) | undefined } },
  apiBase: string,
  source: string,
): void {
  app.config.errorHandler = (err, _instance, info) => {
    const e = err instanceof Error ? err : new Error(String(err))
    reportClientError(apiBase, {
      message: e.message,
      stack: e.stack,
      source,
      kind: 'vue_error_handler',
    })
    console.error(`[${source}]`, info, err)
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (ev) => {
      const r = ev.reason
      reportClientError(apiBase, {
        message: r instanceof Error ? r.message : String(r),
        stack: r instanceof Error ? r.stack : undefined,
        source,
        kind: 'unhandledrejection',
      })
    })
    window.addEventListener('error', (ev) => {
      reportClientError(apiBase, {
        message: ev.message || 'window.error',
        stack: ev.error instanceof Error ? ev.error.stack : undefined,
        source,
        kind: 'window_error',
      })
    })
  }
}
